/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";
import CreditBalanceDetailPanelComponent from "./creditBalanceDetailPanel.component";
import { selectLoading } from "modules/notification";
import { getCreditOverview } from "modules/campaign/consumer-engagement/redux";
import { TngDisbursementContext } from "../tngDisbursementSettingPanel/tngDisbursementSettingPanel.container";

export default function CreditBalanceDetailPanelContainer() {
  const lang = useSelector((state) => state.constant.languages);
  const isFetching = useSelector((state) =>
    selectLoading(state, getCreditOverview.typePrefix)
  );

  const { disbursementInfo, handleOverviewDataLoad, overview, isError } =
    useContext(TngDisbursementContext);

  const [activeIndex, setActiveIndex] = useState(0);

  const defaultBalance = { credit: 0, transaction: 0 };
  const lifetimeClaimedSafe =
    overview?.creditBalances?.lifetimeClaimed ?? defaultBalance;

  return (
    <CreditBalanceDetailPanelComponent
      lang={lang}
      isFetching={isFetching}
      isError={isError}
      handleReload={handleOverviewDataLoad}
      overview={overview}
      disbursementInfo={disbursementInfo}
      setActiveIndex={setActiveIndex}
      activeIndex={activeIndex}
      defaultBalance={defaultBalance}
      lifetimeClaimedSafe={lifetimeClaimedSafe}
    />
  );
}
